/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import { BackofficeUserActivationFieldsFragmentDoc } from '../../../../../areas/admin-panel/user-management/src/lib/UserManagementArea/Users/BackofficeUserActivationFields.hook'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
import { AboutUserFormCardBackofficeUserFragmentDoc } from './AboutUserFormCard.hook'
import { BackofficeUserFormDataFragmentDoc } from './BackofficeUserFormData.hook'

const defaultOptions = {} as const
export type BackofficeUserDetailViewQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input']
}>

export type BackofficeUserDetailViewQuery = {
  __typename?: 'Query'
  backofficeUserById:
    | {
        __typename?: 'BackofficeUser'
        id: string
        username: string
        enabled: boolean
        adminPanelOrganizations: Array<string> | null
        email: string
        signInMethod: Types.BackofficeSignInMethod
        signUpStatus: Types.BackofficeSignUpStatus
        gdpr: boolean
        critical: boolean
        createDate: string
        lastModifiedDate: string
        organizationId: string
        mfaActivated: boolean | null
        customerTenants: Array<string> | null
        firstName: string
        groupsApprover: Array<string>
        lastName: string
        ridepoolingServiceTenants: Array<string> | null
        fleets: Array<string>
        allFleets: boolean
        operatorTenants: Array<string> | null
        systemUser: boolean
        userType: Types.UserType
        backofficeEnabled: boolean | null
        adminPanelEnabled: boolean | null
        timedGroups: Array<{
          __typename?: 'BackofficeUserTimeGroup'
          expires: string | null
          groupName: string
        }>
        timedServiceAreas: Array<{
          __typename?: 'BackofficeUserTimeArea'
          expires: string | null
          serviceArea: string
        }>
      }
    | { __typename?: 'BackofficeUserLimited' }
}

export type BackofficeUserManagementUpdateBackofficeUserMutationVariables =
  Types.Exact<{
    input: Types.BackofficeUserManagementUpdateBackofficeUserInput
  }>

export type BackofficeUserManagementUpdateBackofficeUserMutation = {
  __typename?: 'Mutation'
  backofficeUserManagementUpdateBackofficeUser: {
    __typename?: 'BackofficeUser'
    id: string
    username: string
    enabled: boolean
    adminPanelOrganizations: Array<string> | null
    email: string
    signInMethod: Types.BackofficeSignInMethod
    signUpStatus: Types.BackofficeSignUpStatus
    gdpr: boolean
    critical: boolean
    createDate: string
    lastModifiedDate: string
    organizationId: string
    mfaActivated: boolean | null
    customerTenants: Array<string> | null
    firstName: string
    groupsApprover: Array<string>
    lastName: string
    ridepoolingServiceTenants: Array<string> | null
    fleets: Array<string>
    allFleets: boolean
    operatorTenants: Array<string> | null
    systemUser: boolean
    userType: Types.UserType
    backofficeEnabled: boolean | null
    adminPanelEnabled: boolean | null
    timedGroups: Array<{
      __typename?: 'BackofficeUserTimeGroup'
      expires: string | null
      groupName: string
    }>
    timedServiceAreas: Array<{
      __typename?: 'BackofficeUserTimeArea'
      expires: string | null
      serviceArea: string
    }>
  }
}

export type BackofficeUserManagementEnableBackofficeUserMutationVariables =
  Types.Exact<{
    input: Types.BackofficeUserManagementEnableBackofficeUserInput
  }>

export type BackofficeUserManagementEnableBackofficeUserMutation = {
  __typename?: 'Mutation'
  backofficeUserManagementEnableBackofficeUser: string
}

export type BackofficerUserDetailViewBackofficeUserFragment = {
  __typename?: 'BackofficeUser'
  id: string
  username: string
  enabled: boolean
  adminPanelOrganizations: Array<string> | null
  email: string
  signInMethod: Types.BackofficeSignInMethod
  signUpStatus: Types.BackofficeSignUpStatus
  gdpr: boolean
  critical: boolean
  createDate: string
  lastModifiedDate: string
  organizationId: string
  mfaActivated: boolean | null
  customerTenants: Array<string> | null
  firstName: string
  groupsApprover: Array<string>
  lastName: string
  ridepoolingServiceTenants: Array<string> | null
  fleets: Array<string>
  allFleets: boolean
  operatorTenants: Array<string> | null
  systemUser: boolean
  userType: Types.UserType
  backofficeEnabled: boolean | null
  adminPanelEnabled: boolean | null
  timedGroups: Array<{
    __typename?: 'BackofficeUserTimeGroup'
    expires: string | null
    groupName: string
  }>
  timedServiceAreas: Array<{
    __typename?: 'BackofficeUserTimeArea'
    expires: string | null
    serviceArea: string
  }>
}

export const BackofficerUserDetailViewBackofficeUserFragmentDoc = gql`
    fragment BackofficerUserDetailViewBackofficeUser on BackofficeUser {
  id
  username
  enabled
  ...AboutUserFormCardBackofficeUser
  ...BackofficeUserFormData
  ...BackofficeUserActivationFields
  adminPanelOrganizations
}
    ${AboutUserFormCardBackofficeUserFragmentDoc}
${BackofficeUserFormDataFragmentDoc}
${BackofficeUserActivationFieldsFragmentDoc}`
export const BackofficeUserDetailViewDocument = gql`
    query BackofficeUserDetailView($id: ID!) {
  backofficeUserById(id: $id) {
    ... on BackofficeUser {
      ...BackofficerUserDetailViewBackofficeUser
    }
  }
}
    ${BackofficerUserDetailViewBackofficeUserFragmentDoc}`

/**
 * __useBackofficeUserDetailViewQuery__
 *
 * To run a query within a React component, call `useBackofficeUserDetailViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackofficeUserDetailViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackofficeUserDetailViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBackofficeUserDetailViewQuery(
  baseOptions: Apollo.QueryHookOptions<
    BackofficeUserDetailViewQuery,
    BackofficeUserDetailViewQueryVariables
  > &
    (
      | { variables: BackofficeUserDetailViewQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    BackofficeUserDetailViewQuery,
    BackofficeUserDetailViewQueryVariables
  >(BackofficeUserDetailViewDocument, options)
}
export function useBackofficeUserDetailViewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BackofficeUserDetailViewQuery,
    BackofficeUserDetailViewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BackofficeUserDetailViewQuery,
    BackofficeUserDetailViewQueryVariables
  >(BackofficeUserDetailViewDocument, options)
}
// @ts-ignore
export function useBackofficeUserDetailViewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    BackofficeUserDetailViewQuery,
    BackofficeUserDetailViewQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  BackofficeUserDetailViewQuery,
  BackofficeUserDetailViewQueryVariables
>
export function useBackofficeUserDetailViewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BackofficeUserDetailViewQuery,
        BackofficeUserDetailViewQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  BackofficeUserDetailViewQuery | undefined,
  BackofficeUserDetailViewQueryVariables
>
export function useBackofficeUserDetailViewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BackofficeUserDetailViewQuery,
        BackofficeUserDetailViewQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    BackofficeUserDetailViewQuery,
    BackofficeUserDetailViewQueryVariables
  >(BackofficeUserDetailViewDocument, options)
}
export type BackofficeUserDetailViewQueryHookResult = ReturnType<
  typeof useBackofficeUserDetailViewQuery
>
export type BackofficeUserDetailViewLazyQueryHookResult = ReturnType<
  typeof useBackofficeUserDetailViewLazyQuery
>
export type BackofficeUserDetailViewSuspenseQueryHookResult = ReturnType<
  typeof useBackofficeUserDetailViewSuspenseQuery
>
export type BackofficeUserDetailViewQueryResult = Apollo.QueryResult<
  BackofficeUserDetailViewQuery,
  BackofficeUserDetailViewQueryVariables
>
export const BackofficeUserManagementUpdateBackofficeUserDocument = gql`
    mutation BackofficeUserManagementUpdateBackofficeUser($input: BackofficeUserManagementUpdateBackofficeUserInput!) {
  backofficeUserManagementUpdateBackofficeUser(input: $input) {
    ...BackofficerUserDetailViewBackofficeUser
  }
}
    ${BackofficerUserDetailViewBackofficeUserFragmentDoc}`
export type BackofficeUserManagementUpdateBackofficeUserMutationFn =
  Apollo.MutationFunction<
    BackofficeUserManagementUpdateBackofficeUserMutation,
    BackofficeUserManagementUpdateBackofficeUserMutationVariables
  >

/**
 * __useBackofficeUserManagementUpdateBackofficeUserMutation__
 *
 * To run a mutation, you first call `useBackofficeUserManagementUpdateBackofficeUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackofficeUserManagementUpdateBackofficeUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backofficeUserManagementUpdateBackofficeUserMutation, { data, loading, error }] = useBackofficeUserManagementUpdateBackofficeUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBackofficeUserManagementUpdateBackofficeUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BackofficeUserManagementUpdateBackofficeUserMutation,
    BackofficeUserManagementUpdateBackofficeUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    BackofficeUserManagementUpdateBackofficeUserMutation,
    BackofficeUserManagementUpdateBackofficeUserMutationVariables
  >(BackofficeUserManagementUpdateBackofficeUserDocument, options)
}
export type BackofficeUserManagementUpdateBackofficeUserMutationHookResult =
  ReturnType<typeof useBackofficeUserManagementUpdateBackofficeUserMutation>
export type BackofficeUserManagementUpdateBackofficeUserMutationResult =
  Apollo.MutationResult<BackofficeUserManagementUpdateBackofficeUserMutation>
export type BackofficeUserManagementUpdateBackofficeUserMutationOptions =
  Apollo.BaseMutationOptions<
    BackofficeUserManagementUpdateBackofficeUserMutation,
    BackofficeUserManagementUpdateBackofficeUserMutationVariables
  >
export const BackofficeUserManagementEnableBackofficeUserDocument = gql`
    mutation BackofficeUserManagementEnableBackofficeUser($input: BackofficeUserManagementEnableBackofficeUserInput!) {
  backofficeUserManagementEnableBackofficeUser(input: $input)
}
    `
export type BackofficeUserManagementEnableBackofficeUserMutationFn =
  Apollo.MutationFunction<
    BackofficeUserManagementEnableBackofficeUserMutation,
    BackofficeUserManagementEnableBackofficeUserMutationVariables
  >

/**
 * __useBackofficeUserManagementEnableBackofficeUserMutation__
 *
 * To run a mutation, you first call `useBackofficeUserManagementEnableBackofficeUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackofficeUserManagementEnableBackofficeUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backofficeUserManagementEnableBackofficeUserMutation, { data, loading, error }] = useBackofficeUserManagementEnableBackofficeUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBackofficeUserManagementEnableBackofficeUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BackofficeUserManagementEnableBackofficeUserMutation,
    BackofficeUserManagementEnableBackofficeUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    BackofficeUserManagementEnableBackofficeUserMutation,
    BackofficeUserManagementEnableBackofficeUserMutationVariables
  >(BackofficeUserManagementEnableBackofficeUserDocument, options)
}
export type BackofficeUserManagementEnableBackofficeUserMutationHookResult =
  ReturnType<typeof useBackofficeUserManagementEnableBackofficeUserMutation>
export type BackofficeUserManagementEnableBackofficeUserMutationResult =
  Apollo.MutationResult<BackofficeUserManagementEnableBackofficeUserMutation>
export type BackofficeUserManagementEnableBackofficeUserMutationOptions =
  Apollo.BaseMutationOptions<
    BackofficeUserManagementEnableBackofficeUserMutation,
    BackofficeUserManagementEnableBackofficeUserMutationVariables
  >
